import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=643c454c&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=643c454c&prod&lang=scss&scoped=true&"
import style1 from "./Home.vue?vue&type=style&index=1&id=643c454c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643c454c",
  null
  
)

export default component.exports